import { observable } from 'mobx';

export type MunicipalityResponseArgs = {
  id: number;
  name: string;
};

export type MunicipalityArgs = {
  id: number;
  name: string;
};

export const convertMunicipalityResponseToArgs = (response: MunicipalityResponseArgs) => {
  const args: MunicipalityArgs = {
    id: response.id,
    name: response.name
  };
  return args;
};

export default class Municipality {
  @observable id: number;
  @observable name: string;

  constructor(args: MunicipalityArgs) {
    this.id = args.id;
    this.name = args.name;
  }
}
